<template>
	<header-block :title="title" :border="image ? 0 : null" :bgcolor="image ? '#281C3Bff' : 'white'" :color="image ? 'white' : null"></header-block>
	<transition v-if="filter">
		<div class="head">
			<div class="header" :style="'background-image: url(' + image + ')'">
				<v-row>
					<v-col class="v-col-7 title-col">
						<h1>{{ title }}</h1>
					</v-col>
					<v-col class="v-col-5 count-col">
						<v-span v-if="availableVouchers">{{ filterCount }} voucher{{ filterCount === 1 ? '' : 's' }}</v-span>
					</v-col>
				</v-row>
			</div>
		</div>
	</transition>

	<v-row class="mb-4" v-if="!filter">
		<v-col class="search-col">
			<v-text-field
				ref="search"
				v-model="query"
				prepend-inner-icon="mdi-magnify"
				density="compact"
				label="Search"
				variant="solo"
				:flat="true"
				hide-details
				clearable
				single-line
				bg-color="#eeeeee"
				@click="gotoSearch"
			></v-text-field>
		</v-col>
	</v-row>

	<v-row class="topMenuRow" v-if="!filter && favouriteVouchers && favouriteVouchers.length > 0">
		<v-col class="topMenuCol">
			<v-btn :class="['topTabButton', { selected: !favourites }]" title="" @click="favourites = false">Browse</v-btn>
		</v-col>
		<v-col class="topMenuCol">
			<v-btn :class="['topTabButton', { selected: favourites }]" title="" @click="favourites = true">Favourites</v-btn>
		</v-col>
	</v-row>

	<div v-if="availableVouchers">
		<VoucherList :showDescription="false" :showFavourites="true" @favouriteToggled="(v) => { favouriteToggled(v); }" @onFilterApplied="(count) => { filterCount = count }" :categories="filter" :showAll="false" :vouchers="availableVouchers" :search="false" />
	</div>
	<div v-else>
		<div v-for="i in 4" :key="i" class="mb-2">
			<v-skeleton-loader
				type="list-item-avatar-two-line"
			></v-skeleton-loader>
		</div>
	</div>

	<transition>
		<div v-if="!favourites && !filter && categories && availableVouchers">
			<!-- Parent div to allow odd/even css selectors -->
			<div>
				<div :class="'hubItemWrapper'" v-for="c in this.categories" :key="c.id">
					<CategoryButton @click="navFilter({ title: c.pageTitle, filters: c.providerFilters, image: c.pageImage });"  :image=c.buttonImage :title=c.buttonTitle />
				</div>
			</div>
		</div>
	</transition>

	<transition>
		<div v-if="favourites && favouriteVouchers && !filter" class="mt-2">
			<VoucherList :showFavourites="true" @favouriteToggled="(v) => { favouriteToggled(v); }" :vouchers="availableVouchers.filter(v => v.favourite)" :showAll="true" :search="false" />
		</div>
	</transition>

	<div style="clear:both; "></div>
	
</template>

<script>
import Services from '../mixins/Services';
import HeaderBlock from './elements/HeaderBlock.vue';
import VoucherList from './elements/VoucherList.vue';
import CategoryButton from './elements/CategoryButton.vue';

export default {
	mixins: [Services],
	components: {
		// CustomerLoadWait, 
		HeaderBlock, VoucherList, CategoryButton},
	data() {
		return {
			filter: this.$route.query.filters ?? null,
			filterCount: 0,
			title: this.$route.query.title ?? "Browse all retail cards",
			image: this.$route.query.image ?? null,
			favourites: false,
			favouriteVouchers: null
		}
	},
	methods: {
		onLoad: async function() {
			this._getCategories();
			this._getCustomer();
			this._getAvailableVouchers(() => {
				this.favouriteVouchers = this.availableVouchers.filter(v => v.favourite);
				this.availableVouchers.forEach(v => {
					this._removeUnavailableDiscountProviders(v);
				});

			});
			this._getCustomerVouchers();
		},
		navFilter: function(o) {
			this.$router.push({ path: '/vouchers', query: o });
		},
		gotoSearch: function() {
			this.$router.push({ path: '/vouchers/search' });
		},
		favouriteToggled: function(voucher) {
			if (voucher.favourite) {
				this._removeCustomerFavouriteDiscount(voucher, () => {
					voucher.favourite = !voucher.favourite;
				});
			} else {
				this._addCustomerFavouriteDiscount(voucher, () => {
					voucher.favourite = !voucher.favourite;
				});
			}
		},
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

.header {
	padding-top: 138px;
	background-size: cover;
	background-position: bottom;
	margin: -20px -30px 0px -30px;
	margin-top: -138px;
	color: white;
	p--adding-bottom: 200px;
	height: 300px;
	padding: 30px;
	padding-top: 200px;
	color: white;
	position: relative;
	h1{
		font-size: 28px;
		margin-bottom: 0px;
	}
	margin-bottom: 40px;
}

.header::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: #413655;
	opacity: 0.5;
	pointer-events: none;
}

.title-col {
	position: absolute;
	bottom: 10px;
	left: 10px;
	font-weight: bold;
	z-index: 1;
}
.count-col {
	position: absolute;
	bottom: 10px;
	right: 10px;
	text-align: right;
	font-weight: bold;
	z-index: 1;
}

.topTabButton
{
	margin-top: 0px;
	text-transform: none;
	padding-top: 12px !important;
	padding-bottom: 23px !important;
	vertical-align: middle !important;
	background-color: #ffffff66 !important;
	font-weight: bold;
}

.topTabButton.selected {
    background-color: var(--text-color) !important;
	color: white !important;
}

.topMenuCol {
	padding-left: 3px;
	padding-right: 3px;
	margin-top: 0px;
	padding-top: 0px;
}

.topMenuRow
{
	margin-left: -5px;
	margin-right: -5px;
	margin-top: 0px;
	margin-bottom: 0px;
}

</style>

<style>
/* Dark mode support - responds to parent .dark class */
.dark .header {
	background-color: var(--dark-bg-secondary);
}

.dark .header::before {
	background-color: var(--dark-bg-primary);
}

.dark .topTabButton {
	background-color: var(--dark-bg-secondary) !important;
	color: var(--dark-text-primary) !important;
}

.dark .topTabButton.selected {
	background-color: var(--dark-accent) !important;
	color: white !important;
}

.dark .hubItemWrapper {
	color: var(--dark-text-primary);
}
</style>
